/* tslint:disable */
/* eslint-disable */
/**
 * Kapybro Frontend Api Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: hello@roguepaws.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AiLabelingConfig,
    AiLabelingConfigFromJSON,
    AiLabelingConfigFromJSONTyped,
    AiLabelingConfigToJSON,
    AiSummaryConfig,
    AiSummaryConfigFromJSON,
    AiSummaryConfigFromJSONTyped,
    AiSummaryConfigToJSON,
} from './';

/**
 * 
 * @export
 * @interface AiTriageConfig
 */
export interface AiTriageConfig {
    /**
     * 
     * @type {boolean}
     * @memberof AiTriageConfig
     */
    enabled: boolean;
    /**
     * 
     * @type {AiSummaryConfig}
     * @memberof AiTriageConfig
     */
    summary?: AiSummaryConfig;
    /**
     * 
     * @type {AiLabelingConfig}
     * @memberof AiTriageConfig
     */
    labeling?: AiLabelingConfig;
}

export function AiTriageConfigFromJSON(json: any): AiTriageConfig {
    return AiTriageConfigFromJSONTyped(json, false);
}

export function AiTriageConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): AiTriageConfig {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
        'summary': !exists(json, 'summary') ? undefined : AiSummaryConfigFromJSON(json['summary']),
        'labeling': !exists(json, 'labeling') ? undefined : AiLabelingConfigFromJSON(json['labeling']),
    };
}

export function AiTriageConfigToJSON(value?: AiTriageConfig | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
        'summary': AiSummaryConfigToJSON(value.summary),
        'labeling': AiLabelingConfigToJSON(value.labeling),
    };
}

